import Box from '@mui/material/Box';
import { useAtomValue } from 'jotai';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useCallback } from 'react';

import { useSelectedCurrency } from '../../../../../hooks/useSelectedCurrency';
import { defaultCurrency } from '../../../../../services/state/AppConfigStateJ';
import { CurrencyCode } from '../../../../../util/currency-util';
import { selectedViewPFJ } from '../../../state/ViewStateJ';

export function PortfolioCurrencyToggle() {
  const { selectedCurrency, setSelectedCurrency } = useSelectedCurrency();
  const selectedView = useAtomValue(selectedViewPFJ);

  const handleCurrencyChange = useCallback(
    (_event: React.MouseEvent<HTMLElement>, newCurrency: string | null) => {
      if (newCurrency !== null && newCurrency !== selectedCurrency) {
        setSelectedCurrency(newCurrency as CurrencyCode);
      }
    },
    [selectedCurrency, setSelectedCurrency]
  );

  // Don't render until view is loaded to ensure proper initialization
  if (!selectedView) {
    return null;
  }

  return (
    <Box display='flex' alignItems='center' justifySelf='end'>
      <ToggleButtonGroup
        color={'secondary'}
        value={selectedCurrency}
        exclusive
        onChange={handleCurrencyChange}
        size='small'
      >
        <ToggleButton value='BRL'>BRL</ToggleButton>
        <ToggleButton value={defaultCurrency}>{defaultCurrency}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
